const localeEn = {
  en: {
    LANDING_TITLE1: '¡{{name}},\nWelcome to\n',
    LANDING_TITLE2: 'Crehana!',
    LANDING_COPY:
      'We are the platform allied with {{ORG}} that will boost your professional and personal growth.',
    LANDING_START: 'Explore my panel',

    HEADER_BREADCRUMB_TITLE_1: 'Welcome',
    HEADER_BREADCRUMB_TITLE_2: 'Learn more',
    HEADER_BREADCRUMB_TITLE_3: 'Resources',

    STEPPER_NEXT: 'Continue',
    STEPPER_BACK: 'Back',

    FEATURE_TITLE: 'What we have for you',
    FEATURE_TITLE_1: 'Design your experience',
    FEATURE_DESCRIPTION_1:
      'Customize your information to access learning and development opportunities more relevant to you.',
    FEATURE_TITLE_2: 'Boost your growth',
    FEATURE_DESCRIPTION_2:
      'Access training and learning content designed to enhance your skills and support you in your professional evolution. *',
    FEATURE_TITLE_3: 'Get involved in your development',
    FEATURE_DESCRIPTION_3:
      'Be an active part of assessments, recognitions, and other processes that strengthen your development and that of your team. *',
    FEATURE_INFO: '*According to the products your company purchased',

    RESOURCES_TITLE: 'Help and resources',
    RESOURCES_SUBTITLE_1: 'Chatbot',
    RESOURCES_DESCRIPTION_1:
      'In our platform, we have a support chat to advise you about the use of the platform.',
    RESOURCES_SUBTITLE_2: 'Help Center',
    RESOURCES_DESCRIPTION_2:
      'When you need guides or tutorials, you can also access the "Help" option.',

    POWERED_BY: 'Powered by',
  },
};

export default localeEn;
